import moment from "moment";

export class Bill {
  constructor(billData) {
    this.billData = billData;
  }

  get id() {
    try {
      return this.billData.BillInfo.bill_id;
    } catch (e) {
      return 0;
    }
  }

  get companyName() {
    return this.billData?.CompanyUnitName ?? "";
  }

  get partnerOrderName() {
    try {
      return this.billData.BillInfo.order;
    } catch (e) {
      return "0000";
    }
  }

  get createdAtDateTime() {
    try {
      return moment(this.billData.BillInfo.dt).format("DD.MM.YYYY, HH:mm:ss");
    } catch (e) {
      return "00.00.0000, 00:00:00";
    }
  }

  get createdAtDate() {
    try {
      return moment(this.billData.BillInfo.dt).format("DD.MM.YYYY");
    } catch (e) {
      return "00.00.0000";
    }
  }

  get payerFullName() {
    try {
      let _fullNameParts = this.billData.UserFullName.split(" ");

      let _lastName = _fullNameParts[0] || "";

      if (_lastName.length > 2) {
        let _lastNameFirstChar = _lastName[0],
          _lastNameLastChar = _lastName[_lastName.length - 1];

        _lastName =
          _lastNameFirstChar +
          "".padEnd(_lastName.length, "*") +
          _lastNameLastChar;
      } else if (_lastName.length > 0 && _lastName.length <= 2) {
        let _lastNameFirstChar = _lastName[0];

        _lastName = _lastNameFirstChar + "".padEnd(2, "*");
      }

      return {
        firstname: _fullNameParts[1] || "",
        lastname: _lastName,
        middlename: "",
        toString: () => [_lastName, _fullNameParts[1] || ""].join(" "),
      };
    } catch (e) {
      return {
        firstname: "",
        lastname: "",
        middlename: "",
        toString: () => this.transactionData?.billData ?? "",
      };
    }
  }

  get payerFullNamePlain() {
    return {
      firstname: "",
      lastname: "",
      middlename: "",
      toString: () => this.billData?.UserFullName ?? "",
    };
  }

  get sum() {
    try {
      return parseInt(this.billData.OperationSum) / 100;
    } catch (e) {
      return 0;
    }
  }

  get currencyPlain() {
    try {
      return this.billData.TransactionCurrency;
    } catch (e) {
      return "";
    }
  }

  get expAt() {
    try {
      return moment(this.billData.BillInfo.exp_dt).format("DD.MM.YYYY");
    } catch (e) {
      return "00.00.0000";
    }
  }

  get link() {
    try {
      return this.billData.BillInfo.bill_link;
    } catch (e) {
      return "";
    }
  }

  get phoneEmail() {
    try {
      return this.billData.BillInfo.phone || this.billData.BillInfo.email;
    } catch (e) {
      return "";
    }
  }

  get email() {
    try {
      return this.billData.BillInfo.email ?? "";
    } catch (e) {
      return "";
    }
  }

  get phone() {
    try {
      return this.billData.BillInfo.phone ?? "";
    } catch (e) {
      return "";
    }
  }

  get purpose() {
    try {
      return this.billData.BillInfo.purpose;
    } catch (e) {
      return "";
    }
  }

  get comment() {
    try {
      return this.billData.BillInfo.comment;
    } catch (e) {
      return "";
    }
  }

  get operationId() {
    try {
      return this.billData.OperationID;
    } catch (e) {
      return "";
    }
  }

  get operationStatus() {
    try {
      return this.billData.OperationStatus;
    } catch (e) {
      return 0;
    }
  }

  get lang() {
    try {
      return this.billData.BillInfo.lang;
    } catch (e) {
      return "uk";
    }
  }

  get refunds() {
    try {
      return this.billData.Refunds || [];
    } catch (e) {
      return [];
    }
  }

  get pan() {
    try {
      return this.billData.Card || "";
    } catch (e) {
      return "";
    }
  }

  get canRefund() {
    try {
      return this.billData.CanRefund || false;
    } catch (e) {
      return false;
    }
  }

  /**
   *
   * @returns {boolean}
   */
  get canCancelPreAuth() {
    try {
      return !!this.CanRefund?.PreAuthId;
    } catch (e) {
      return false;
    }
  }

  get partnerTransactionId() {
    try {
      return this.billData.PartnerTransactionID || "0";
    } catch (e) {
      return "0";
    }
  }
}
